// Define quadrants for the dental notation system
export const quadrant1 = [18, 17, 16, 15, 14, 13, 12, 11]; // Top Left
export const quadrant2 = [21, 22, 23, 24, 25, 26, 27, 28]; // Top Right
export const quadrant3 = [31, 32, 33, 34, 35, 36, 37, 38]; // Bottom Right
export const quadrant4 = [48, 47, 46, 45, 44, 43, 42, 41]; // Bottom Left
